import Typography from "@/components/Typography/Typography";
import { Tag } from "antd";

export default function QuoteCreationTypeTag({
  quoteCreationType,
}: {
  quoteCreationType: "Firm" | "Budgetary";
}) {
  if (quoteCreationType === "Budgetary") {
    return (
      <Tag className=" rounded-full " color="#FFF3D8">
        <Typography type="span" fontSize={14} className="text-yellow-secondary">
          {quoteCreationType}
        </Typography>
      </Tag>
    );
  }
  return (
    <Tag className="rounded-full " color="#d8f2d4">
      <Typography type="span" fontSize={14} className="text-success-dark">
        {quoteCreationType}
      </Typography>
    </Tag>
  );
}
